/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Keep_Open_WarningInputs */

const en_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please leave this window open until your export completes`)
};

const fr_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez laisser cette fenêtre ouverte jusqu'à la fin de l'exportation`)
};

const de_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte lassen Sie dieses Fenster so lange geöffnet, bis Ihr Export abgeschlossen ist.`)
};

const it_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si prega di lasciare aperta questa finestra fino al completamento dell'esportazione`)
};

const ru_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, оставьте это окно открытым до завершения экспорта.`)
};

const es_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deje esta ventana abierta hasta que se complete la exportación.`)
};

const zh_cn2_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请保持此窗口打开，直到导出完成。`)
};

const ja_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートが完了するまでこのウィンドウを開いたままにしてください`)
};

const hi_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया निर्यात पूरा होने तक इस विंडो को खुला रखें।`)
};

const pt_pt2_audio_description_export_keep_open_warning = /** @type {(inputs: Audio_Description_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, deixe esta janela aberta até que a exportação seja concluída.`)
};

/**
* | output |
* | --- |
* | "Please leave this window open until your export completes" |
*
* @param {Audio_Description_Export_Keep_Open_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_keep_open_warning = /** @type {((inputs?: Audio_Description_Export_Keep_Open_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Keep_Open_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_keep_open_warning(inputs)
	if (locale === "de") return de_audio_description_export_keep_open_warning(inputs)
	if (locale === "it") return it_audio_description_export_keep_open_warning(inputs)
	if (locale === "ru") return ru_audio_description_export_keep_open_warning(inputs)
	if (locale === "es") return es_audio_description_export_keep_open_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_keep_open_warning(inputs)
	if (locale === "ja") return ja_audio_description_export_keep_open_warning(inputs)
	if (locale === "hi") return hi_audio_description_export_keep_open_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_keep_open_warning(inputs)
	return en_audio_description_export_keep_open_warning(inputs)
});